module.exports = __webpack_public_path__ + "img/set.58e1c2bb.svg";